<template>
  <div class="section--column--center">
    <div class="TwoFactorWizardstep-size-security">
      <p><strong>{{ $t('TwoFactorAuth.InfQuestion1')}}</strong></p>
      <p>{{ $t('TwoFactorAuth.InfDesc1')}}</p>
      <p><strong>{{ $t('TwoFactorAuth.InfQuestion2')}}</strong></p>
      <p>{{ $t('TwoFactorAuth.InfDesc2')}}</p>
      <p><strong>{{ $t('TwoFactorAuth.InfQuestion2')}}</strong></p>
      <p>{{ $t('TwoFactorAuth.InfDesc3')}}</p>
    </div>
    <button @click="toContinue"
            class="btn btn-primary p-x-2 border__rounded btn-2fa">{{ $t('wizard.next')}}
    </button>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, ref} from "vue";
import {AuthenticatorValidationStatus} from "@/types/autenticationresult";
import TwoFactorAuthenticationAPPService from "@/services/TwoFactorAuth/TwoFactorAuthenticationAPP.service";
import {useStore} from "vuex";

export default defineComponent({
  name: 'infoauthapp2fa',
  components: {
  },
  setup() {

    const store = useStore();
    const toContinue = () => {
      TwoFactorAuthenticationAPPService.setTwoFactorAuthenticationProcessWizard(true, store);
    }
    //
    return {
      toContinue
    }
  }
});

</script>


<style scoped>


</style>
